/* tslint:disable */
/* eslint-disable */
/**
 * goal-wear
 * API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Collection } from '../models';
// @ts-ignore
import type { CollectionLatest } from '../models';
// @ts-ignore
import type { CollectionProducts } from '../models';
// @ts-ignore
import type { CollectionWrite } from '../models';
// @ts-ignore
import type { PatchedCollectionWrite } from '../models';
/**
 * CollectionsApi - axios parameter creator
 * @export
 */
export const CollectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CollectionWrite} collectionWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsCreateCreate: async (collectionWrite: CollectionWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionWrite' is not null or undefined
            assertParamExists('productsCollectionsCreateCreate', 'collectionWrite', collectionWrite)
            const localVarPath = `/api/products/collections/create/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsDestroy: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsCollectionsDestroy', 'id', id)
            const localVarPath = `/api/products/collections/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsLatestRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/products/collections/latest/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/products/collections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {PatchedCollectionWrite} [patchedCollectionWrite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsPartialUpdate: async (id: number, patchedCollectionWrite?: PatchedCollectionWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsCollectionsPartialUpdate', 'id', id)
            const localVarPath = `/api/products/collections/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCollectionWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsProductsRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsCollectionsProductsRetrieve', 'id', id)
            const localVarPath = `/api/products/collections/{id}/products/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsCollectionsRetrieve', 'id', id)
            const localVarPath = `/api/products/collections/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CollectionWrite} collectionWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsUpdate: async (id: number, collectionWrite: CollectionWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsCollectionsUpdate', 'id', id)
            // verify required parameter 'collectionWrite' is not null or undefined
            assertParamExists('productsCollectionsUpdate', 'collectionWrite', collectionWrite)
            const localVarPath = `/api/products/collections/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollectionsApi - functional programming interface
 * @export
 */
export const CollectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CollectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CollectionWrite} collectionWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCollectionsCreateCreate(collectionWrite: CollectionWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCollectionsCreateCreate(collectionWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.productsCollectionsCreateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCollectionsDestroy(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCollectionsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.productsCollectionsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCollectionsLatestRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionLatest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCollectionsLatestRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.productsCollectionsLatestRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCollectionsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Collection>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCollectionsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.productsCollectionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {PatchedCollectionWrite} [patchedCollectionWrite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCollectionsPartialUpdate(id: number, patchedCollectionWrite?: PatchedCollectionWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Collection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCollectionsPartialUpdate(id, patchedCollectionWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.productsCollectionsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCollectionsProductsRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionProducts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCollectionsProductsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.productsCollectionsProductsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCollectionsRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Collection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCollectionsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.productsCollectionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {CollectionWrite} collectionWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsCollectionsUpdate(id: number, collectionWrite: CollectionWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsCollectionsUpdate(id, collectionWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionsApi.productsCollectionsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CollectionsApi - factory interface
 * @export
 */
export const CollectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CollectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {CollectionsApiProductsCollectionsCreateCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsCreateCreate(requestParameters: CollectionsApiProductsCollectionsCreateCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionWrite> {
            return localVarFp.productsCollectionsCreateCreate(requestParameters.collectionWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CollectionsApiProductsCollectionsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsDestroy(requestParameters: CollectionsApiProductsCollectionsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productsCollectionsDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsLatestRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<CollectionLatest> {
            return localVarFp.productsCollectionsLatestRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<Collection>> {
            return localVarFp.productsCollectionsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CollectionsApiProductsCollectionsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsPartialUpdate(requestParameters: CollectionsApiProductsCollectionsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Collection> {
            return localVarFp.productsCollectionsPartialUpdate(requestParameters.id, requestParameters.patchedCollectionWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CollectionsApiProductsCollectionsProductsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsProductsRetrieve(requestParameters: CollectionsApiProductsCollectionsProductsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionProducts> {
            return localVarFp.productsCollectionsProductsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CollectionsApiProductsCollectionsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsRetrieve(requestParameters: CollectionsApiProductsCollectionsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Collection> {
            return localVarFp.productsCollectionsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CollectionsApiProductsCollectionsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsCollectionsUpdate(requestParameters: CollectionsApiProductsCollectionsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionWrite> {
            return localVarFp.productsCollectionsUpdate(requestParameters.id, requestParameters.collectionWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productsCollectionsCreateCreate operation in CollectionsApi.
 * @export
 * @interface CollectionsApiProductsCollectionsCreateCreateRequest
 */
export interface CollectionsApiProductsCollectionsCreateCreateRequest {
    /**
     * 
     * @type {CollectionWrite}
     * @memberof CollectionsApiProductsCollectionsCreateCreate
     */
    readonly collectionWrite: CollectionWrite
}

/**
 * Request parameters for productsCollectionsDestroy operation in CollectionsApi.
 * @export
 * @interface CollectionsApiProductsCollectionsDestroyRequest
 */
export interface CollectionsApiProductsCollectionsDestroyRequest {
    /**
     * 
     * @type {number}
     * @memberof CollectionsApiProductsCollectionsDestroy
     */
    readonly id: number
}

/**
 * Request parameters for productsCollectionsPartialUpdate operation in CollectionsApi.
 * @export
 * @interface CollectionsApiProductsCollectionsPartialUpdateRequest
 */
export interface CollectionsApiProductsCollectionsPartialUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof CollectionsApiProductsCollectionsPartialUpdate
     */
    readonly id: number

    /**
     * 
     * @type {PatchedCollectionWrite}
     * @memberof CollectionsApiProductsCollectionsPartialUpdate
     */
    readonly patchedCollectionWrite?: PatchedCollectionWrite
}

/**
 * Request parameters for productsCollectionsProductsRetrieve operation in CollectionsApi.
 * @export
 * @interface CollectionsApiProductsCollectionsProductsRetrieveRequest
 */
export interface CollectionsApiProductsCollectionsProductsRetrieveRequest {
    /**
     * 
     * @type {number}
     * @memberof CollectionsApiProductsCollectionsProductsRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for productsCollectionsRetrieve operation in CollectionsApi.
 * @export
 * @interface CollectionsApiProductsCollectionsRetrieveRequest
 */
export interface CollectionsApiProductsCollectionsRetrieveRequest {
    /**
     * 
     * @type {number}
     * @memberof CollectionsApiProductsCollectionsRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for productsCollectionsUpdate operation in CollectionsApi.
 * @export
 * @interface CollectionsApiProductsCollectionsUpdateRequest
 */
export interface CollectionsApiProductsCollectionsUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof CollectionsApiProductsCollectionsUpdate
     */
    readonly id: number

    /**
     * 
     * @type {CollectionWrite}
     * @memberof CollectionsApiProductsCollectionsUpdate
     */
    readonly collectionWrite: CollectionWrite
}

/**
 * CollectionsApi - object-oriented interface
 * @export
 * @class CollectionsApi
 * @extends {BaseAPI}
 */
export class CollectionsApi extends BaseAPI {
    /**
     * 
     * @param {CollectionsApiProductsCollectionsCreateCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    public productsCollectionsCreateCreate(requestParameters: CollectionsApiProductsCollectionsCreateCreateRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).productsCollectionsCreateCreate(requestParameters.collectionWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CollectionsApiProductsCollectionsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    public productsCollectionsDestroy(requestParameters: CollectionsApiProductsCollectionsDestroyRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).productsCollectionsDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    public productsCollectionsLatestRetrieve(options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).productsCollectionsLatestRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    public productsCollectionsList(options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).productsCollectionsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CollectionsApiProductsCollectionsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    public productsCollectionsPartialUpdate(requestParameters: CollectionsApiProductsCollectionsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).productsCollectionsPartialUpdate(requestParameters.id, requestParameters.patchedCollectionWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CollectionsApiProductsCollectionsProductsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    public productsCollectionsProductsRetrieve(requestParameters: CollectionsApiProductsCollectionsProductsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).productsCollectionsProductsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CollectionsApiProductsCollectionsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    public productsCollectionsRetrieve(requestParameters: CollectionsApiProductsCollectionsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).productsCollectionsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CollectionsApiProductsCollectionsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionsApi
     */
    public productsCollectionsUpdate(requestParameters: CollectionsApiProductsCollectionsUpdateRequest, options?: RawAxiosRequestConfig) {
        return CollectionsApiFp(this.configuration).productsCollectionsUpdate(requestParameters.id, requestParameters.collectionWrite, options).then((request) => request(this.axios, this.basePath));
    }
}

